import { SearchMenu } from './SearchMenu'
import { withSearchMenu } from './withSearchMenu'

const ConnectedSearchMenu = withSearchMenu(SearchMenu)
export { ConnectedSearchMenu as SearchMenu }
